import type { OmnichannelMessage } from '@/types';

const messageTime = (message: OmnichannelMessage): number => {
  const raw = message.created_time ?? message.createdAt;
  if (!raw) return 0;
  const ms = new Date(raw).getTime();
  return Number.isNaN(ms) ? 0 : ms;
};

/** Union by id; incoming (API) wins on conflict so websocket-only rows are kept. */
export const mergeOmnichannelMessageLists = (
  existing: OmnichannelMessage[],
  incoming: OmnichannelMessage[]
): OmnichannelMessage[] => {
  const byId = new Map<string, OmnichannelMessage>();

  for (const message of existing) {
    if (message?.id) byId.set(message.id, message);
  }

  for (const message of incoming) {
    if (message?.id) byId.set(message.id, message);
  }

  return Array.from(byId.values()).sort(
    (a, b) => messageTime(a) - messageTime(b)
  );
};
